import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, Globe, Star, Instagram } from "lucide-react";
import { api, imageUrl } from "@/lib/api";
import EventCard from "@/components/EventCard";

export default function VenueDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [venue, setVenue] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => {
    api.get(`/venues/${slug}`).then((r) => setVenue(r.data)).catch(() => setNf(true));
  }, [slug]);

  if (nf) return <div className="py-24 text-center font-display text-4xl text-white uppercase">Venue Not Found</div>;
  if (!venue) return <div className="py-20 text-center text-zinc-500">Loading…</div>;

  return (
    <div className="pb-16">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 pt-4">
        <button data-testid="back-to-venues" onClick={() => navigate("/venues")} className="inline-flex items-center gap-1.5 font-oswald text-xs font-semibold tracking-widest text-zinc-300 hover:text-white">
          <ArrowLeft size={15} /> BACK TO VENUES
        </button>
      </div>

      <div className="mx-auto max-w-5xl px-4 sm:px-6 mt-4">
        <div className="relative aspect-[16/9] overflow-hidden rounded-2xl border border-[#27272A]">
          <img src={imageUrl(venue.hero_image)} alt={venue.name} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            {venue.abe_owned ? (
              <span className="inline-flex items-center gap-1 rounded bg-[#D4AF37] px-2 py-1 font-oswald text-[10px] font-bold tracking-widest text-black mb-2"><Star size={11} /> ABE VENUE</span>
            ) : (
              <span className="inline-block rounded bg-black/70 px-2 py-1 font-oswald text-[10px] font-bold tracking-widest text-white mb-2">PARTNER VENUE</span>
            )}
            <h1 className="font-display text-4xl sm:text-5xl uppercase text-white leading-none">{venue.name}</h1>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-4 text-sm text-zinc-300">
          {venue.address && <span className="inline-flex items-center gap-2"><MapPin size={16} className="text-[#D4AF37]" />{venue.address}, {venue.city}</span>}
          {venue.website && <a href={venue.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white"><Globe size={16} className="text-[#D4AF37]" />Website</a>}
          {venue.instagram && <a href={venue.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white"><Instagram size={16} className="text-[#D4AF37]" />Instagram</a>}
        </div>

        {venue.description && <p className="mt-5 text-zinc-300 leading-relaxed">{venue.description}</p>}

        {venue.gallery && venue.gallery.length > 1 && (
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {venue.gallery.map((g, i) => (
              <img key={i} src={imageUrl(g)} alt="" className="aspect-square object-cover rounded-lg border border-[#27272A]" />
            ))}
          </div>
        )}

        <div className="mt-12">
          <span className="section-eyebrow">Upcoming</span>
          <h2 className="font-display text-3xl uppercase text-white mt-2 mb-5 leading-none">Events at {venue.name}</h2>
          {venue.events && venue.events.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {venue.events.map((ev) => <EventCard key={ev.id} event={ev} />)}
            </div>
          ) : (
            <div className="rounded-xl border border-[#27272A] p-10 text-center">
              <p className="font-display text-xl text-white uppercase">No Upcoming Events Here</p>
              <Link to="/events" className="text-[#D4AF37] text-sm mt-2 inline-block">Browse all events →</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
